var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "translate(0.5)",
    fill: "#564FFD",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.25 27.5H26.75C26.4185 27.5 26.1005 27.6317 25.8661 27.8661C25.6317 28.1005 25.5 28.4185 25.5 28.75V53.75L30.5 51.25L35.5 53.75L40.5 51.25L45.5 53.75L50.5 51.25L55.5 53.75V28.75C55.5 28.4185 55.3683 28.1005 55.1339 27.8661C54.8995 27.6317 54.5815 27.5 54.25 27.5ZM38 45H30.5V35H38V45Z",
    fill: "#564FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 53.75V28.75C25.5 28.4185 25.6317 28.1005 25.8661 27.8661C26.1005 27.6317 26.4185 27.5 26.75 27.5H54.25C54.5815 27.5 54.8995 27.6317 55.1339 27.8661C55.3683 28.1005 55.5 28.4185 55.5 28.75V53.75L50.5 51.25L45.5 53.75L40.5 51.25L35.5 53.75L30.5 51.25L25.5 53.75Z",
    stroke: "#564FFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37.5H50.5",
    stroke: "#564FFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42.5H50.5",
    stroke: "#564FFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35H30.5V45H38V35Z",
    stroke: "#564FFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.0755af4b394a7c2ec0e227999365f91c.svg";
export { ForwardRef as ReactComponent };